import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthAdminProvider } from "./context/AuthAdminProvider";
import { BrowserRouter } from "react-router-dom";
import { MassageSelectProvider } from "./context/MassageSelectProvider";
import { ConsultationSelectProvider } from "./context/ConsultationSelectProvider";
import { AnnonceProvider } from "./context/AnnonceProvider";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthAdminProvider>
      <MassageSelectProvider>
        <ConsultationSelectProvider>
          <AnnonceProvider>
            <App />
          </AnnonceProvider>
        </ConsultationSelectProvider>
      </MassageSelectProvider>
    </AuthAdminProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();